.container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 1;
  overflow: hidden;
}

.top-section {
  display: flex;
  flex-direction: column;
  min-width: 100%;
  margin-top: 1.6rem;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  min-width: 100%;
  max-width: 100%;
  order: 1;
  gap: 0.4rem;

  & > div {
    min-width: 100%;
    padding: 0 1.6rem;
  }

  & > svg {
    display: none;
  }

  @media screen and (min-width: #{$bp-medium - 1}) {
    order: 2;
    gap: 1.6rem;

    // This is the space selector
    & > div {
      & > div {
        padding: 0;
        flex-direction: column;
        gap: 0.4rem;

        & > svg:last-child {
          display: none;
        }

        & > div {
          & > p,
          & > span:last-child {
            display: none;
          }
        }
      }
    }

    & > svg {
      display: block;
      height: 2.4rem;
      fill: #ffffff;
    }
  }
}

.user-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.6rem 1.6rem 3.2rem 1.6rem;
  background: var(--color-grayscale-charleston, #25272d);
  order: 3;
  cursor: pointer;

  @media screen and (min-width: $bp-medium) {
    display: none;
  }
}

.current-user-div {
  display: flex;
  align-items: center;
  gap: 0.8rem;
  min-width: 0;
}

.user-name-email-wrapper {
  display: flex;
  flex-direction: column;
  height: 3.2rem;

  span:first-child {
    color: var(--color-grayscale-white, #fafafa);
    font-size: 1.4rem;
    font-weight: 500;
  }

  span:last-child {
    color: var(--color-grayscale-shuttle, #626878);
    font-size: 1.2rem;
    font-weight: 400;
    max-width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.icon-wrapper {
  padding: 0.4rem;
}
